import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface Batch {
  count: number;
  createdAt: string;
  failedCount: number;
  finishedAt: string | null;
  id: string;
  isReleased: boolean;
  releasedAt?: string | null;
  successCount: number;
}

export const getParentsOnboardingBatches = async () => {
  const response = await baseAPI.get<Array<Batch>>(
    `parents/onboarding/batches`,
  );
  return response.data;
};

export const useGetParentsOnboardingBatches = () => {
  return useQuery({
    queryKey: [KEYS.PARENTS_ONBOARDING_BATCHES],
    queryFn: () => getParentsOnboardingBatches(),
    placeholderData: keepPreviousData,
  });
};
